import { createIcon } from '../../../utils/createIcon';

const IconTransactionReport = createIcon({
  d: 'M16.25 2.5H3.75004C2.83337 2.5 2.08337 3.25 2.08337 4.16667V15.8333C2.08337 16.75 2.83337 17.5 3.75004 17.5H16.25C17.1667 17.5 17.9167 16.75 17.9167 15.8333V4.16667C17.9167 3.25 17.1667 2.5 16.25 2.5ZM16.25 4.16667V6.66667H3.75004V4.16667H16.25ZM12.0834 15.8333H7.91671V8.33333H12.0834V15.8333ZM3.75004 8.33333H6.25004V15.8333H3.75004V8.33333ZM13.75 15.8333V8.33333H16.25V15.8333H13.75Z',
  viewBox: '0 0 20 20',
  fill: 'white',
});

export default IconTransactionReport;
